import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { TripBoard } from "../components/TripBoard";
import { Seo } from "../components/Seo";
import { fetchItinerary } from "../lib/api";
import { Toaster } from "sonner";
import { ArrowRight, Sparkle } from "@phosphor-icons/react";

export default function Trip() {
  const { id } = useParams();
  const [itin, setItin] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchItinerary(id)
      .then(setItin)
      .catch(() =>
        setError("This trip-board could not be found — it may have expired."),
      );
  }, [id]);

  return (
    <div className="min-h-screen pb-mobile-nav" data-testid="trip-page">
      <Seo
        title={
          itin?.title
            ? `${itin.title} — shared trip-board`
            : "Shared Flycher trip-board"
        }
        description={
          itin
            ? `A ${itin?.days?.length || ""}-day ${itin?.country || ""} trip-board crafted with Flycher AI. View day-by-day plan, activities, stay ideas, and budget tips.`
            : "A friend shared their Flycher AI trip-board with you. View the full day-by-day plan."
        }
        path={`/trip/${id}`}
        noindex
      />
      <Toaster theme="light" position="top-center" offset={80} />
      <Navbar />
      <div className="pt-24 max-w-7xl mx-auto px-5 sm:px-8 pb-24">
        <div
          className="rounded-2xl px-5 py-3 mb-6 inline-flex items-center gap-2 text-xs font-semibold"
          style={{
            background: "rgba(42,127,184,0.10)",
            color: "#2A7FB8",
          }}
        >
          <Sparkle size={14} weight="fill" />
          A friend shared their Flycher trip-board with you
        </div>

        {error && (
          <div className="card-surface rounded-2xl p-10 text-center">
            <h2 className="font-serif text-3xl text-slate-900">{error}</h2>
            <Link
              to="/itinerary"
              className="inline-flex items-center gap-2 mt-5 px-5 py-3 rounded-full font-semibold text-white"
              style={{ background: "#FF7E4D" }}
            >
              Plan your own trip <ArrowRight size={14} weight="bold" />
            </Link>
          </div>
        )}

        {!itin && !error && (
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="card-surface rounded-2xl p-6 h-32 animate-pulse"
              />
            ))}
          </div>
        )}

        {itin && (
          <>
            <TripBoard itin={itin} slug={itin.country_slug} readOnly />
            <div className="mt-12 card-surface rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:justify-between">
              <div>
                <span className="kicker">— Inspired?</span>
                <h3 className="font-serif text-2xl sm:text-3xl mt-2 text-slate-900">
                  Generate your own budget itinerary in seconds.
                </h3>
              </div>
              <Link
                to="/itinerary"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full font-semibold text-white shadow-md shadow-orange-200/70"
                style={{ background: "#FF7E4D" }}
              >
                Plan my trip <ArrowRight size={14} weight="bold" />
              </Link>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
